export default __webpack_public_path__ + "static/media/unavsaTwo.58d4332d.png";